import { render, staticRenderFns } from "./SimClassDetails.vue?vue&type=template&id=447a09d3&scoped=true"
import script from "./SimClassDetails.vue?vue&type=script&lang=js"
export * from "./SimClassDetails.vue?vue&type=script&lang=js"
import style0 from "./SimClassDetails.vue?vue&type=style&index=0&id=447a09d3&prod&lang=css"
import style1 from "./SimClassDetails.vue?vue&type=style&index=1&id=447a09d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a09d3",
  null
  
)

export default component.exports